<template>
	<div class="photoUpload">
		<div class="photoUpload-box">
			<ul class="show-image">
				<li><img :src="imgList" v-if="imgList"></li>
			</ul>
			<el-upload
				:action="baseUrl+'/api/upload'"
				list-type="picture-card"
				:on-success='successUpload'
				>
				<i class="el-icon-plus"></i>
			</el-upload>
		</div>
		
	</div>
</template>

<script>
	export default{
		props:['imgList','uploadImg'],
		data(){
			return{
				baseUrl:process.env.apiUrl
			}
		},
		methods:{
			successUpload:function(response, file, fileList){
				// console.log(file)
				var vm=this;
				this.$emit('uploadImg',file.response.data)
			}
		},
		mounted(){
			
		},
	}
</script>

<style>
	.photoUpload-box{
		display: flex;
	}
	.show-image{
		display: flex;
	}
	.show-image li>img{
		height: 60px;
		width: 60px;
		margin-right: 10px;
		
	}
	
</style>



// WEBPACK FOOTER //
// src/components/public/photoUpload.vue